import React, { Component } from 'react';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

export class CartonisedModalYesNoWithComment extends Component {
    render() {
        let msg = '';
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.onClick} backdrop="static" centered>
                    <Modal.Header style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Modal.Title>{this.props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>{this.props.message}
                        {/*<br></br><br></br>*/}
                        {/*<input autoFocus="autofocus" className="form-control" type="text" placeholder="note..."*/}
                        {/*     onChange={(e) => {*/}
                        {/*        msg = e.target.value;*/}
                        {/*    }}*/}
                        {/* />*/}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.props.onClickNo}>
                            No
                        </Button>
                        <Button variant="primary" onClick={() => this.props.onClickYes(msg)}>
                            Yes
                         </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default CartonisedModalYesNoWithComment;
